import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { AsientoContable } from '../../../models/asiento-contable';
import { Pago } from '../../../models/pago';
import { AsientoContableService } from '../../../services/asiento-contable.service';
import { PagoService } from '../../../services/pago.service';
import { AjusteInventarioModalComponent } from '../ajuste-inventario-modal/ajuste-inventario-modal.component';
import { CompraModalComponent } from '../compra-modal/compra-modal.component';
import { MovimientoBancarioModalComponent } from '../movimiento-bancario-modal/movimiento-bancario-modal.component';
import { NotacreditoModalComponent } from '../notacredito-modal/notacredito-modal.component';
import { RetencionCompraModalComponent } from '../retencion-compra-modal/retencion-compra-modal.component';
import { RetencionModalComponent } from '../retencion-modal/retencion-modal.component';
import { VentaModalComponent } from '../venta-modal/venta-modal.component';
import * as moment from 'moment';
import { Cobro } from '../../../models/cobro';
import { CobroService } from '../../../services/cobro.service';
import { UtilsService } from '../../../services/utils.service';
@Component({
  selector: 'app-asiento-contable-detalle-modal',
  templateUrl: './asiento-contable-detalle-modal.component.html',
  styleUrls: ['./asiento-contable-detalle-modal.component.css'],
  providers: [
    AsientoContableService, PagoService, CobroService
  ],
})
export class AsientoContableDetalleModalComponent implements OnInit {
  @Input() asiento_id: String;
  @Input()  tipo_transaccion_contabilidad_id: String;
  public asientoContable: AsientoContable;
  public loading: boolean;
  public numero_decimales: number;
  public bsModalRef: BsModalRef;
  public pago: Pago;
  public cobro:Cobro;
  public loadingM: boolean;
  public asiento:AsientoContable;
  public total_tarjetas: number;
  public total_efectivo: number;
  public total_transferencia: number;
  public total_cheques: number;
  public calculo_decimales = 2;
  constructor(
    private pagoService: PagoService,
    private cobroService: CobroService,
    private modalService: BsModalService,
    private asientoContableService: AsientoContableService,
    public bsModalRef2: BsModalRef,
    public utils: UtilsService,
  ) { 
    this.loading = false;
    this.loadingM = false;
    this.numero_decimales = 2;
    this.asientoContable = new AsientoContable();
    this.cobro = new Cobro();
    this.pago = new Pago();
    this.asiento = new AsientoContable();
    this.total_cheques = 0;
    this.total_efectivo = 0;
    this.total_tarjetas = 0;
    this.total_transferencia = 0;
    this.calculo_decimales = 2;
  }

  

  ngOnInit() {
    this.loading = true;
    this.getAsientoById().then(
      res => this.loading = false,
      err => this.loading = false,
    )
  }

  getCodigo(asientoContable){
    return (asientoContable.is_automatico) ? (asientoContable.tipotransaccion?asientoContable.tipotransaccion.etiqueta:'') + '-' + this.fill(asientoContable.codigo, 8) : this.fill(asientoContable.codigo, 8);
  }

  fill (number, len) {
    if(number.length < 8)
      return "0".repeat(len - number.toString().length) + number.toString();
    return number;
  }

  onShowComprobante(asiento, template: TemplateRef<any> = null){
    if(asiento.tipo_transaccion_contabilidad_id == '1') {
      const initialState = {compra_id: asiento.compra.id, numero_decimales: this.numero_decimales};
		  this.bsModalRef = this.modalService.show(CompraModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));  
    }else if(asiento.tipo_transaccion_contabilidad_id == '2') {
      const initialState = {venta_id: asiento.venta.id, numero_decimales: this.numero_decimales};
		  this.bsModalRef = this.modalService.show(VentaModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
    }else if(asiento.tipo_transaccion_contabilidad_id == '6') {
      const initialState = {retencion_id: asiento.retencionventa.id, numero_decimales: this.numero_decimales};
		  this.bsModalRef = this.modalService.show(RetencionModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
    }else if(asiento.tipo_transaccion_contabilidad_id == '5') {
      const initialState = {retencion_id: asiento.retencioncompra.id, numero_decimales: this.numero_decimales};
		  this.bsModalRef = this.modalService.show(RetencionCompraModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
    }else if(asiento.tipo_transaccion_contabilidad_id == '7' || asiento.tipo_transaccion_contabilidad_id == '8') {
      const initialState = {ajuste_id: asiento.ajuste.id, numero_decimales: this.numero_decimales};
		  this.bsModalRef = this.modalService.show(AjusteInventarioModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
    }else if(asiento.tipo_transaccion_contabilidad_id == '9' || asiento.tipo_transaccion_contabilidad_id == '10') {
      const initialState = {movimiento_id: asiento.movimiento.id, numero_decimales: this.numero_decimales};
		  this.bsModalRef = this.modalService.show(MovimientoBancarioModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
    }else if(asiento.tipo_transaccion_contabilidad_id == '3' || asiento.tipo_transaccion_contabilidad_id == '4') {
      const initialState = {nota_credito_id: asiento.notacredito.id, numero_decimales: this.numero_decimales};
		  this.bsModalRef = this.modalService.show(NotacreditoModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
    }else if(asiento.tipo_transaccion_contabilidad_id == '11'){
      this.pago = new Pago();
      this.total_cheques = 0;
      this.total_efectivo = 0;
      this.total_tarjetas = 0;
      this.total_transferencia = 0;
      // this.proveedor = new Proveedor();
      // this.compra = new Compra();
      this.loadingM = true;
      let qs = '?embed=detalle?embed=formapago,banco,grupo?embed=compra';
        this.pagoService.getById(asiento.pago.id, qs).subscribe( 
          res => {
            this.loadingM = false;
            this.pago = res.pago;
            console.log(this.pago);
            this.asiento = asiento;
            this.pago.detalle.forEach(detalle => {
              detalle.valor = this.utils.redondear(detalle.valor,this.calculo_decimales);
              if(detalle.forma_pago_id == '1'){
                this.total_efectivo += detalle.valor;
              }
              if(detalle.forma_pago_id == '2'){
                this.total_cheques += detalle.valor;
              }
              if(detalle.forma_pago_id == '3'){
                this.total_tarjetas += detalle.valor;
              }
              if(detalle.forma_pago_id == '6'){
                this.total_transferencia += detalle.valor;
              }
            });
          },
          err => {
            this.loadingM = false;
            this.pago = new Pago();
          }
        );
  
      const initialState = {  };
  
      this.bsModalRef = this.modalService.show(template, Object.assign({class: 'modal-xlg'}, {initialState}));
    }else if(asiento.tipo_transaccion_contabilidad_id == '12'){
      this.cobro = new Cobro();
      this.total_cheques = 0;
      this.total_efectivo = 0;
      this.total_tarjetas = 0;
      this.total_transferencia = 0;
      this.loadingM = true;
      let qs = '?embed=detalle?embed=formapago,banco,grupo?embed=venta';
      
        this.cobroService.getById(asiento.cobro.id, qs).subscribe( 
          res => {
            this.loadingM = false;
            this.cobro = res;
            this.asiento = asiento;
            this.cobro.detalle.forEach(detalle => {
              detalle.valor = this.utils.redondear(detalle.valor,this.calculo_decimales);
              if(detalle.forma_pago_id == '1'){
                this.total_efectivo += detalle.valor;
              }
              if(detalle.forma_pago_id == '2'){
                this.total_cheques += detalle.valor;
              }
              if(detalle.forma_pago_id == '3'){
                this.total_tarjetas += detalle.valor;
              }
              if(detalle.forma_pago_id == '6'){
                this.total_transferencia += detalle.valor;
              }
            });
          },
          err => {
            this.loadingM = false;
            this.cobro = new Cobro();
          }
        );
  
      const initialState = {  };
  
      this.bsModalRef = this.modalService.show(template, Object.assign({class: 'modal-xlg'}, {initialState}));
    }
		  
		
  }

  getFecha(fecha){
    if( fecha )
      return fecha = moment(fecha).format("DD/MM/YYYY");
    return fecha;
  }

  getPagoDetalle(id){
    return this.pago.detalle.filter(d => d.forma_pago_id == id);
  }

  getCobroDetalle(id){
    return this.cobro.detalle.filter(d => d.forma_pago_id == id);
  }


  getAsientoById(){
    let documento = "";
    if ( this.tipo_transaccion_contabilidad_id == '1' ) {
      documento = "compra";
    }else if (this.tipo_transaccion_contabilidad_id == '2') {
      documento = 'venta';
    }else if (this.tipo_transaccion_contabilidad_id == '6') {
      documento = 'retencionventa';
    }else if (this.tipo_transaccion_contabilidad_id == '5') {
      documento = 'retencioncompra';
    }else if (this.tipo_transaccion_contabilidad_id == '7' || this.tipo_transaccion_contabilidad_id == '8') {
      documento = 'ajuste';
    }else if (this.tipo_transaccion_contabilidad_id == '9' || this.tipo_transaccion_contabilidad_id == '10') {
      documento = 'movimiento';
    }
    else if (this.tipo_transaccion_contabilidad_id == '3' || this.tipo_transaccion_contabilidad_id == '4') {
      documento = 'notacredito';
    }
    else if (this.tipo_transaccion_contabilidad_id == '11') {
      documento = 'pago';
    }else if (this.tipo_transaccion_contabilidad_id == '12') {
      documento = 'cobro';
    }
    // else if (this.tipo_documento == 'RC') {
    //   DOCUME
    // }
    let qs = '?embed=tipocomprobante,tipotransaccion,'+ documento +',periodo,detalle?embed=cuenta';
    return new Promise ( (resolve, reject) => {
      this.asientoContableService.getById(this.asiento_id, qs).subscribe(
        res => {
            this.asientoContable = res.data;
            resolve(true);
        },
        err => {
            reject();
        }
      );
    });
    
  }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/asiento-contable-modal/asiento-contable-detalle-modal.component.ts